// Custom JS

// Add equalizer for submenu products
function equalheight(container) {
    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPostion = 0,
        currentDiv;
    $(container).each(function () {
        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

$(document).ready(function () {

    //Your Addresses : customer name wrap in span
    $('.address p, .single-order-page .order-address p, .account-address p').html(function (i, html) {
        return html.replace(/(\w+\s\w+)/, '<span>$1</span>')
    });

    // Multiple tabs starts //
    $(".tab-content").hide();
    $(".tab-content:first").show();

    $("ul.tabs li").click(function () {

        $(".tab-content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).fadeIn("fast");

        $("ul.tabs li").removeClass("tab-active");
        $(this).addClass("tab-active");

        $(".tab-header").removeClass("m_tab_active");
        $(".tab-header[rel^='" + activeTab + "']").addClass("m_tab_active");

    });

    $(".tab-header").click(function () {

        $(".tab-content").hide();
        var m_tab_activeTab = $(this).attr("rel");
        $("#" + m_tab_activeTab).slideToggle();

        $(".tab-header").removeClass("m_tab_active");
        $(this).addClass("m_tab_active");
        $("ul.tabs li").removeClass("tab-active");
        $("ul.tabs li[rel^='" + m_tab_activeTab + "']").addClass("tab-active");

        // Scroll to the tabs title only in mobile devices
        if( $(window).width() < 768 ) {
            $('html, body').animate({
                scrollTop: $(this).offset().top
            }, 1000);
        }

    });
    // Multiple tabs ends //

    // slick slider for image text carousel section
    $('.better-skin-carousal-section').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true
    });
    // Slider for Product Detail Page last Step Setup
    //show and hide arrow of product detail page--:

    var productSlider = $('.product-detail-carousal-section').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        dots: true
    });

    $('.slick-prev').hide();

    // Hide and show next and prev arrow
    productSlider.on('afterChange', function (event, slick, currentSlide) {
        //If we're on the first slide hide the Previous button and show the Next
        if (currentSlide === 0) {
            $('.slick-prev').hide();
            $('.slick-next').show();
        } else {
            $('.slick-prev').show();
        }

        //If we're on the last slide hide the Next button.
        if (slick.slideCount === currentSlide + 1) {
            $('.slick-next').hide();
        }
        else{
          $('.slick-next').show();
        }
    });


    // Products Selection Steps
    var mainStep = $('.product-selection-steps'),
        step1 = mainStep.find('.step-1'),
        step1Btn = step1.find('.type-selection'),
        step2 = mainStep.find('.step-2');


    //Hide step-2 first time on page load
    step2.hide();

    // Step 1
    step1Btn.on('click', function () {
        step1.hide();
        step2.show();
        var tag = $(this).attr('data-tag');
        step2.find("[parent_tag='" + tag + "']").show();
    })

    //show title first on megamenu--
    var submenuText = jQuery('.gm-submenu .gm-target').find('.gm-text');
    submenuText.contents()
        .filter(function () {
            return this.nodeType !== 1;
        })
        .wrap('<span class="title"></span>');


    var submenuLi = jQuery('.gm-submenu .gm-grid').find('.gm-grid-item');

    submenuLi.each(function () {
        var title = jQuery(this).find("span.title");
        var img = jQuery(this).find("img");
        title.insertBefore(img);
    });

    //add class on first li on megamenu--
    $('.gm-submenu-align-full').first().addClass('gm-first-product');

    // Add equalizer for submenu products
    $(".mobile-nav-wrapper, .gm-menu.gm-menu-mobile > .gm-level-0 > .gm-submenu").addClass("visibilityshow");

    equalheight(".gm-image > a > .title");

    setTimeout(function () {
        $(".mobile-nav-wrapper, .gm-menu.gm-menu-mobile > .gm-level-0 > .gm-submenu").removeClass("visibilityshow");
    }, 500);

    // Hide Instafeed div in IE-11 (As instafeed app doesn't support IE-11)
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (isIE11) {
        $('.instagram-module').hide();
        $('#insta-feed').hide();
    }

    //add and reduce quantity--
    $('#plus').click(function () {
        if ($(this).prev().val() == $(this).prev().val()) {
            $(this).prev().val(+$(this).prev().val() + 1);
        }
    });

    $('#minus').click(function () {
        if ($(this).next().val() > 1) {
            if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
        }
    });

    equalheight(".gm-image > a > .title");
    $(".mobile-nav-wrapper .gm-menu .gm-item.gm-level-0>.gm-target").click(function () {
        setTimeout(function () {
            equalheight(".gm-image > a > .title");
        }, 10);
    });

    //background overlay on mobile deviec.
    $(".site-header__icon.js-mobile-nav-toggle").click(function () {
        $(".mobile-bg-overlay").toggleClass("overlay-active");
    });

    //add  parent class on menu hover
    $(".site-nav li.gm-has-submenu").hover(function(){
            $(this).parent().addClass("menu-hover-active");
        }, function () {
            $(this).parent().removeClass("menu-hover-active");
    });


    //hide quantity on onclick of subscrption---
    $(document).on('click', '.bold-ro__recurring-text', function () {
        //hide extra content on product detail page--
        $('.bold-ro__fixed-frequency-text').html('(order will ship every month until cancelled)');
        $('#qty_number').hide(500);
        $('#Quantity-product-template').val(1);
    });

    //show quantity on onclick of one time purchase
    $(document).on('click', '.bold-ro__one-time-purchase', function () {
        $('#qty_number').show(500);
    });

    // Show more and less
    var showMoreBtn = $('.btn-show-more'),
        showLessBtn = $('.btn-show-less'),
        moduleClass = '.learn-more-module',
        mobileWidth = 751,
        learnMoreContentClass = '.learn-more-content';

    showLessBtn.click(function () {
        var sectionId = $(this).attr('data-section-id');
        var mainModule = $(this).parents(moduleClass);

        mainModule.find("[data-parent-id='" + sectionId + "']").slideUp('slow');
        mainModule.find(showMoreBtn).show();
    });

    showMoreBtn.click(function () {
        var sectionId = $(this).attr('data-section-id');
        var btnType = $(this).attr('data-btn-type');
        var mainModule = $(this).parents(moduleClass);
        var learnMoreSection = mainModule.find("[data-parent-id='" + sectionId + "']");
        learnMoreSection.slideDown('slow');
        $(this).hide();
        mainModule.find(showMoreBtn).hide();

        // Scroll only in mobile case
        if( $(window).width() < mobileWidth ) {
            if (btnType == "left") {
              var getFirstChild = learnMoreSection.find('.feature-row__item:first');
              if (getFirstChild.length > 0) {
                  $('html, body').animate({
                      scrollTop: $(getFirstChild).offset().top
                  }, 1000);
              }

            }

            if (btnType == "right") {
                var getLastChild = learnMoreSection.find('.feature-row__item:last');
                if (getLastChild.length > 0) {
                    $('html, body').animate({
                        scrollTop: $(getLastChild).offset().top
                    }, 1000);
                }
            }
        }

    });


    var el = $("ul#mobile-menu-items").find('li a[href$="/pages/shop"]');
    if (el.length > 0) {
      el.parent().removeClass('gm-has-submenu gm-submenu-mega gm-submenu-align-full').addClass('has-submenu-mob');
      el.html('<span class="gm-text">Shop</span>');
      el.after('<span class="gm-retractor gm-has-submenu gm-submenu-mega gm-submenu-align-full"></span>');
    }

    if( $(window).width() < 1200 ) {
      var el = $("ul#SiteNav").find('li a[href$="/pages/shop"]');
        if (el.length > 0) {
        el.parent().removeClass('gm-has-submenu gm-submenu-mega').addClass('has-submenu-tab');;
        const descHtml = el.parent().find('div.gm-submenu.gm-mega').html();
        const html = `
        <div class="sub-nav-tab-wrapper">
        <a href="/pages/shop" class="gm-target js-no-transition">
        <span class="gm-text">Shop</span>
        </a>
        <span class="gm-retractor gm-has-submenu gm-submenu-mega gm-submenu-align-full"></span>
        </div>
        <div class="gm-submenu gm-mega">
        ${descHtml}
        </div>
        `
        el.parent().html(html);
      }
      $(".gm-retractor").click(function(){
        //$(".has-submenu-tab").toggleClass("gm-active");
        //alert("nmm");
      });
    }
  
  	hashUrl();

    // Page scroll when window hash URL
    function hashUrl() {
      if (window.location.hash) {
        var hashText = window.location.hash.substring(1);
        
        $("div").each(function() {
          if($(this).attr("data-parent-id") === hashText) {
            var $this = $(this);
            $this.show();
            $this.parent().find(showMoreBtn).hide();
            setTimeout(function(){
              var offsetTop = $this.parent().offset().top;
              $("html, body").animate({ scrollTop: offsetTop}, 500);
            }, 400);
            window.location.hash = hashText;
          }
        });
      }
    }


});

//Add equalizer for submenu products on resize the window
$(window).on('resize', function () {
    equalheight(".gm-image > a > .title");

    if( $(window).width() < 1200 ) {
      var el = $("ul#SiteNav").find('li a[href$="/pages/shop"]');
        if (el.length > 0) {
        el.parent().removeClass('gm-has-submenu gm-submenu-mega').addClass('has-submenu-tab');;
        const descHtml = el.parent().find('div.gm-submenu.gm-mega').html();
        const html = `
        <div class="sub-nav-tab-wrapper">
        <a href="/pages/shop" class="gm-target js-no-transition">
        <span class="gm-text">Shop</span>
        </a>
        <span class="gm-retractor gm-has-submenu gm-submenu-mega gm-submenu-align-full"></span>
        </div>
        <div class="gm-submenu gm-mega">
        ${descHtml}
        </div>
        `
        el.parent().html(html);
      }
      $(".gm-retractor").click(function(){
        //$(".has-submenu-tab").toggleClass("gm-active");
        //alert("nmm");
      });
    }

});
